<template>
  <div>
    <v-row class="mt-10 justify-center">
      <v-flex lg5 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1">비밀번호</p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <v-text-field
          v-model="passwordValue1"
          :append-icon="passwordShow1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="passwordShow1 ? 'text' : 'password'"
          label="비밀번호를 입력해주세요"
          class="input-group--focused"
          @click:append="passwordShow1 = !passwordShow1"
          single-line
          outlined
          dense
        ></v-text-field>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1">비밀번호 확인</p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <v-text-field
          v-model="passwordValue2"
          :append-icon="passwordShow2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="passwordShow2 ? 'text' : 'password'"
          label="비밀번호를 한번 더 입력해주세요"
          class="input-group--focused"
          @click:append="passwordShow2 = !passwordShow2"
          single-line
          outlined
          dense
        ></v-text-field>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <v-btn color="primary" class="col-12" height="42" @click="passwordSave"
          >저장</v-btn
        >
      </v-flex>
    </v-row>

    <Alert ref="Alert"></Alert>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import Alert from "@/components/common/Alert.vue";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data() {
    return {
      M,
      passwordShow1: false,
      passwordShow2: false,
      password: "Password",
      mallId: "",
      passwordValue1: "",
      passwordValue2: "",
    };
  },
  mixins: [CommonMixin],
  methods: {
    passwordSave: async function() {
      if (!this.passwordValue1 || !this.passwordValue2) {
        this.alertShow("비밀번호를 입력해주세요.");
        return false;
      }

      if (this.passwordValue1 != this.passwordValue2) {
        this.alertShow(
          "입력하신 비밀번호가 다릅니다.<br>다시 확인 후 입력해주세요."
        );
        return false;
      }

      try {
        await M.api(M.entry("/users/password/update"), {
          password: this.passwordValue1,
          mall_id: this.mallId,
        });
        this.alertShow("입력하신 비밀번호로 변경되었습니다.");
      } catch (e) {
        this.alertShow("비밀번호 변경이 실패되었습니다.");
      }
    },
  },
  components: {
    Alert,
  },
  created: function() {
    let urlParams = new URLSearchParams(window.location.search);
    let mallId = urlParams.get("mallId");

    if (!mallId) {
      alert("잘못된 접근 입니다.");
      location.href = "/shoplus_service";
    } else {
      this.mallId = mallId;
    }
  },
};
</script>
